module.exports = __webpack_public_path__ + "img/visionBack.39896332.jpg";